<input
  type="text"
  maxlength="25"
  class="input is-medium"
  [formControl]="control"
  [placeholder]="'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUP-NAME-PLACEHOLDER' | translate" />

<div class="actions-container">
  @if (hasValidInput()) {
    <i
      [matTooltip]="'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUP-SAVE' | translate"
      [matTooltipShowDelay]="500"
      class="icon icon-check_clear"
      (click)="onCheckClicked(control.value)"></i>
    <div
      class="vertical-divider"
      [style.height]="'calc(100% - .25rem)'"></div>
  }

  <topo-close
    size="large"
    [matTooltip]="'MANAGEMENT.COMMUNICATION-CENTER.CANCEL' | translate"
    [matTooltipShowDelay]="500"
    (onClick)="clearInput()" />
</div>
